<template>
  <div class="menu">
    <div class="top-title border-b border-section_border" id="top-title">
      <h1 class="top-title-heading">
        <img src="@/assets/images/plan-title-back.png" alt="旅行プランニングサービス" class="title-logo" />
      </h1>
    </div>

    <Notice/>

    <div id="top-description" class="m-4">
      <p v-html="$t('main_description')"></p>
      <div class="mt-4 text-sm">
        <ul class="list-note">
          <li>
            {{ $t('sub_description2') }}
          </li>
        </ul>
      </div>
    </div>

    <MyPlan/>

    <div v-if="this.$store.getters['user/getToken'] === null">
      <div id="top-description" class="m-4">
        <a class="button-primary block" @click="openRecoveryCode">リカバリーコードを入力</a>
      </div>
    </div>
    <div v-else-if="this.$store.getters['user/getProfile'] !== null">
      <div id="top-description" class="m-4">
        <a class="button-primary block" @click="openPlanSetting">旅行日程・便名等の基本設定（変更）</a>
      </div>
    </div>

    <CourseList @openPlanTerms="openPlanTerms" @openPlanSetting="openPlanSetting" />

    <PoiList @openPlanTerms="openPlanTerms" @openPlanSetting="openPlanSetting" @registration="registration" />

    <div v-if="showPlanSetting">
      <PlanSetting @closePlanSetting="closePlanSetting" />
    </div>

    <div v-if="showRecoveryCode">
      <RecoveryCode @closeRecoveryCode="closeRecoveryCode" />
    </div>

    <div v-if="showPlanTerms">
      <PlanTerms @closePlanTerms="closePlanTerms" @openPlanSetting="openPlanSetting" />
    </div>

    <div class="mt-4 px-4">
      <router-link :to="{ name: 'faq' }" class="button-secondary block button-icon icon-right">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span v-html="$t('faq_label')"></span>
      </router-link>
    </div>

    <div v-if="this.$store.getters['user/getToken'] !== null" class="mt-4 px-4">
      <a :href="questionnaire_url()" class="button-secondary w-full block button-icon icon-right" target="_blank">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>アンケートにご協力ください</span>
      </a>
    </div>

    <div class="m-4 text-sm" id="top-notice">
      <ul class="list-note">
        <li>
          {{ $t('disclaimer_description1') }}
        </li>
        <li>
          {{ $t('disclaimer_description2') }}
        </li>
        <li>
          {{ $t('disclaimer_description3') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MyPlan from '../components/organisms/MyPlan.vue'
import CourseList from '../components/organisms/CourseList.vue'
import PoiList from '../components/organisms/PoiList.vue'
import PlanSetting from '../components/organisms/PlanSetting.vue'
import RecoveryCode from '../components/organisms/RecoveryCode.vue'
import PlanTerms from '../components/organisms/PlanTerms.vue'
import Notice from '../components/organisms/Notice.vue'
import Constants from '../constants'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')


export default {
  name: 'Top',
  components: {
    MyPlan,
    CourseList,
    PoiList,
    PlanSetting,
    RecoveryCode,
    PlanTerms,
    Notice
  },
  data () {
    return {
      showPlanSetting: false,
      showRecoveryCode: false,
      showPlanTerms: false,
      place: null
    }
  },
  mounted () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('flight/fetchAll')
    this.$store.dispatch('places/fetchAll')
      .then(() => {
        this.$store.dispatch('loading/endLoading')
        if (this.$store.getters['user/getChangeProfile'] !== null) {
          this.showPlanSetting = true
        }
      })
    if (this.$store.getters['user/getToken'] !== null) {
      this.$store.dispatch('favorites/fetchAll')
    }
    this.$gtag.event("サイト訪問", {
      date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
      token: this.$store.getters['user/getToken']
    });
  },
  methods: {
    openPlanSetting: function () {
      this.showPlanSetting = true
    },
    closePlanSetting: function () {
      this.showPlanSetting = false
    },
    openPlanTerms: function () {
      this.showPlanTerms = true
    },
    closePlanTerms: function () {
      if (this.place === null) {
        this.showPlanTerms = false
        this.showPlanSetting = true
      } else {
        this.$store.dispatch('loading/beginLoading')
        this.$store.dispatch('plans/createToken')
          .then(() => {
            const params = {
              token: this.$store.getters['user/getToken'],
              id: Constants.API_ID
            }
            this.$store.dispatch('user/updateProfile', params)
              .then(() => {
                const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
                if (favoriteGenre !== undefined) {
                  this.$store.dispatch('places/updateFavoritePlace', { id: this.place.id, favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
                }
                this.$store.dispatch('favorites/create', this.place)
                  .then(() => {
                    this.showPlanTerms = false
                  })
                  .catch(() => this.$alert({ message: this.$t('system_error_message') }))
                  .finally(() => {
                    this.$store.dispatch('loading/endLoading')
                    this.$router.push({ name: 'registered' })
                  })
              })
          })
      }
    },
    openRecoveryCode: function () {
      this.showRecoveryCode = true
    },
    closeRecoveryCode: function () {
      this.showRecoveryCode = false
    },
    questionnaire_url: function () {
      if (this.$store.getters['user/getToken'] !== null) {
        return Constants.QUESTIONNAIRE_URL + "?usp=pp_url&entry.1567784294="+ this.$store.getters['user/getToken']
      }
    },
    registration: function (place) {
      this.place = place
      this.showPlanTerms = true
    }
  }
}
</script>

<style scoped>
</style>
